export default class FuncionalidadesEnum {
    static UpdateFilaCanalEmailId = 2011
    static UpdateFilaCanalWhatsAppId = 2088
    static UpdateFilaCanalAberturaManualId = 2104
    static UpdateFilaCanalAutoatendimentoId = 2080
    static UpdateFilaCanalBotId = 2088
    static UpdateFilaTipoSolicitacaoId = 2179
}
